import { useEffect, useState } from 'react';
import { assetUrl } from '~/helpers';

const defaultFallbackThumbnail = assetUrl('assets/images/no-thumbnail.jpg');

export interface UseThumbnailWithFallbackHookArgs {
  imageUrl?: string;
  fallbackThumbnail?: string;
}

export interface UseThumbnailWithFallbackHookResponse {
  thumbnail: string;
  onThumbnailLoadError: () => void;
  isUsingFallbackThumbnail: boolean;
}

/**
 * Provides the thumbnail and the onError fallback when the thumbnail fails to load
 * which sets the thumbnail to the default no thumbnail image.
 * @param imageUrl
 * @returns UseThumbnailWithFallbackHookResponse
 */
export function useThumbnailWithFallback({
  imageUrl,
  fallbackThumbnail = defaultFallbackThumbnail,
}: UseThumbnailWithFallbackHookArgs) {
  const [thumbnail, setThumbnail] = useState(imageUrl ?? fallbackThumbnail);

  useEffect(() => {
    if (imageUrl) {
      setThumbnail(imageUrl);
    }
  }, [imageUrl]);

  return {
    thumbnail,
    onThumbnailLoadError: () => setThumbnail(fallbackThumbnail),
    isUsingFallbackThumbnail: thumbnail === fallbackThumbnail,
  } as UseThumbnailWithFallbackHookResponse;
}
